module.exports = __webpack_public_path__ + "static/media/c3d_logo_on_black.111813bc.svg";